import React, { useEffect, useRef, useState } from "react";
import { chevronBottom } from "../SVG";

export default function SelectInputWithImg({
  selected = null,
  list,
  onChange,
  value,
  error,
  errorText,
  label,
  readOnly,
}) {
  const wrapper = useRef(null);
  const [active, setActive] = useState(false);
  //   const [currentList, setCurrentList] = useState(list);
  const [currentSelected, setCurrentSelected] = useState(selected);
  const onClick = (item) => {
    setCurrentSelected(item);
    if (onChange) onChange(item);

    setActive(false);
  };

  const toggleActive = () => {
    if (!readOnly) {
      setActive(!active);
    }
  };

  // useEffect(() => {
  //   if (currentSelected)
  //     setCurrentList(
  //       list.filter((item) => {
  //         let compareKey = key ?? "value";
  //         return item[compareKey] !== currentSelected[compareKey];
  //       })
  //     );
  // }, [currentSelected]);

  useEffect(() => {
    setCurrentSelected(selected);
  }, [selected]);

  useEffect(() => {
    const windowClick = ({ target }) => {
      if (!wrapper.current.contains(target)) setActive(false);
    };

    if (active) window.addEventListener("click", windowClick);
    else window.removeEventListener("click", windowClick);

    return () => window.removeEventListener("click", windowClick);
  }, [active]);
  return (
    <div className={"select " + (active ? "active" : "")} ref={wrapper}>
      {label && <div className="select__label">{label}</div>}
      <div
        className={
          "select__selected withImg rounded-xl border-gray-100 p-3 hover:border-blue-200 hover:border-2" +
          (error && value === "" && !active ? "error" : "")
        }
        onClick={toggleActive}
      >
        {currentSelected ? (
          <>
            <img
              style={{ width: "28px", height: "28px", borderRadius: "50%" }}
              src={
                currentSelected.profileImg &&
                currentSelected.profileImg &&
                currentSelected.profileImg !== ""
                  ? currentSelected.profileImg
                  : `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`
              }
              onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`;
              }}
              alt="avatar"
            />
            <span>{currentSelected.displayname}</span>
          </>
        ) : (
          <span>-Select an option-</span>
        )}
        {chevronBottom}
      </div>
      <ul
        className={"select__options !rounded-xl " + (active ? "active" : "")}
        style={{
          scrollbarWidth: "thin",
          scrollbarColor: "#e5e7eb transparent",
          top: "calc(100% - (-2px))",
        }}
      >
        {list.map((item, index) => (
          <li
            className="select__option"
            key={index}
            onClick={() => onClick(item)}
          >
            {item.displayname}
          </li>
        ))}
      </ul>
      <ul
        className={"select__options !rounded-xl " + (active ? "active" : "")}
        style={{
          scrollbarWidth: "thin",
          scrollbarColor: "#e5e7eb transparent",
          top: "calc(100% - (-2px))",
        }}
      >
        {list.map((item, index) => (
          <li
            className="select__option selectWithImg hover:!bg-gray-50"
            key={index}
            onClick={() => onClick(item)}
          >
            <img
              style={{ width: "28px", height: "28px", borderRadius: "50%" }}
              src={
                item.profileImg && item.profileImg && item.profileImg !== ""
                  ? item.profileImg
                  : `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`
              }
              onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`;
              }}
              alt="avatar"
            />

            <span className="select__value">{item.displayname}</span>
          </li>
        ))}
      </ul>
      {error && value === "" && !active && (
        <div className="select__error">{errorText}</div>
      )}
    </div>
  );
}
